const PROFILE_FORM_KEY = "vendor_edit_profile_form_draft";
const PROFILE_FRESH_FLAG_KEY = "vendor_edit_profile_fresh_flag";

export interface ProfileFormDraft {
  name: string;
  phone: string;
  city: string;
  state: string;
  address: string;
  pincode: string;
  gstNumber: string;
  panNumber: string;
  // Note: Profile image cannot be persisted, so we exclude it
}

export const saveProfileDraft = (data: Partial<ProfileFormDraft>): void => {
  try {
    // Exclude file fields as they cannot be serialized
    const { profileImage, ...serializableData } = data as any;
    localStorage.setItem(PROFILE_FORM_KEY, JSON.stringify(serializableData));
  } catch (error) {
    console.error("Failed to save profile form draft:", error);
  }
};

export const loadProfileDraft = (): ProfileFormDraft | null => {
  try {
    const raw = localStorage.getItem(PROFILE_FORM_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error("Failed to load profile form draft:", error);
    return null;
  }
};

export const clearProfileDraft = (): void => {
  localStorage.removeItem(PROFILE_FORM_KEY);
};

export const markProfileFreshStart = (): void => {
  localStorage.setItem(PROFILE_FRESH_FLAG_KEY, "true");
};

export const clearProfileFreshFlag = (): void => {
  localStorage.removeItem(PROFILE_FRESH_FLAG_KEY);
};

export const isProfileFreshStart = (): boolean => {
  return localStorage.getItem(PROFILE_FRESH_FLAG_KEY) === "true";
};

